<template>
  <div><!-- <div>placeholder for Intercom Chat --></div>
</template>

<script>
// TODO call $chatService.show() directly instead of using this component.
export default {
  name: 'ChatBot',
  mounted () {
    try {
      this.$chatService.show();
    } catch (e) {
      console.warn(e); // throw console warning on exception
    }
  },
  data () {
    return {}
  }
}
</script>
